import Job from '@/models/Job'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    recentAddedJobsList: [],
    recentAddedJobsListMeta: {},
    recentViewedJobsList: [],
    recentViewedJobsListMeta: {},
    jobDetails: null
  },

  mutations: {
    setJobList(state, { jobs, list }) {
      each(jobs, job => {
        const exist = find(state[list], { id: job.id })
        if (!exist) {
          state[list].push(new Job(job))
        }
      })
    },

    setJobListMeta(state, { meta, list }) {
      state[list + 'Meta'] = meta
    },

    clearJobList(state, list = 'list') {
      state[list] = []
      state[list + 'Meta'] = {}
    },

    setJobDetails(state, job) {
      if (job instanceof Job) {
        state.jobDetails = job
      } else {
        state.jobDetails = new Job(job)
      }
    },

    clearJobDetails(state) {
      state.jobDetails = null
    },

    setJobListItemDetails(state, job) {
      const index = findIndex(state.list, { id: job.id })
      state.list[index].title = job.title
      state.list[index].location = job.location
      state.list[index].created_at = job.created_at
    },

    clearJobListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    }
  },

  actions: {
    async getJobs({ commit }, params) {
      let query = Job.page(params.page || 1)
        .custom('tools')
        .limit(params.limit)
        .include(['gallery'])

      let list = 'list'
      if (params.mine) {
        query.custom('auth/my-tools')
      } else if (params.recently_added) {
        list = 'recentAddedJobsList'
        query.orderBy('-created_at')
      } else if (params.recently_viewed) {
        list = 'recentViewedJobsList'
        query.custom('tools/recently-viewed')
      }

      if (params.filters) {
        if (params.filters.search) {
          query.where('search', params.filters.search)
        }
        if (params.filters.within_distance_to) {
          query.where('within_distance_to', params.filters.within_distance_to)
        }

        if (params.filters.sorting) {
          query.orderBy(params.filters.sorting)
        }
      }

      const res = await query.get(params)

      commit('setJobList', { jobs: res.data, list: list })
      commit('setJobListMeta', { meta: res.meta, list: list })
    },

    async getJobSuggestions({ commit }, formData) {
      let query = Job.page(1)
        .custom('tools/suggest')
        .limit(4)

      query.where('search', formData.search)
      const res = await query.get()

      let items = []
      if (res.data && res.data[0]) {
        items = res.data[0].items
      }

      return {
        items: items
      }
    },

    async getJobDetails({ commit, rootState }, params) {
      const { data } = await Api.get(
        `tools/${params.id}${params.isView ? '?is_view=true' : ''}`
      )
      commit('setJobDetails', data.data)
    },

    async createJob({ commit, state }, formData) {
      await Api.post(`auth/my-tools`, formData)
    },

    async updateJob({ commit, state }, formData) {
      await Api.put(`auth/my-tools/${formData.permalink}`, formData)
    },

    async deleteJobs({ commit, state }, formData) {
      return Api.delete(`auth/my-tools`, { data: formData })
    },

    async uploadJobImage({ commit, state }, formData) {
      await Api.post(
        `auth/my-tools/${formData.permalink}/media`,
        formData.images
      )
    },

    async removeJobImage({ commit, state }, formData) {
      await Api.delete(
        `auth/my-tools/${formData.permalink}/media/${formData.id}`
      )
    },

    async rentCalculate({ commit }, formData) {
      return Api.post('rent/calculate', formData)
    },

    async rentJob({ commit }, formData) {
      return Api.post('rent-requests', formData)
    }
  }
}
